import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../../environments/environment";
import { TreatmentPrices } from "./price.model";
import { HttpClient } from "@angular/common/http";

const API_ENDPOINT = environment.API_ENDPOINT + "/prices";

@Injectable()
export class PriceService {
  patients: Observable<Array<Document>>;

  constructor(private http: HttpClient) {}

  getPrices(): Observable<TreatmentPrices> {
    return this.http.get<TreatmentPrices>(`${API_ENDPOINT}`);
  }

  updatePrices(prices: TreatmentPrices): Observable<TreatmentPrices> {
    return this.http.post<TreatmentPrices>(`${API_ENDPOINT}`, prices);
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/price/price.service.ts